"use client"

import { Button, ButtonProps } from "@/components/ui/button"
import { cn } from "@/lib/utils"
import { Value } from "@stringtale/react"
import Link from "next/link"
import { forwardRef } from "react"

const StartButton = forwardRef<
  HTMLButtonElement,
  ButtonProps & {
    user: any | null
  }
>(({ className, user, variant, size, ...props }, ref) => {
  if (user) {
    return (
      <Button
        asChild
        className={className}
        ref={ref}
        variant={variant || "cta"}
        size={size || "lg"}
        {...props}
      >
        <Link href="/app" className="text-center no-underline">
          <Value name="apps.app.app.(public).layout.dashboard">Dashboard</Value>
        </Link>
      </Button>
    )
  }
  return (
    <Button
      asChild
      className={cn(className, "text-center no-underline")}
      variant={variant || "cta"}
      size={size || "lg"}
      ref={ref}
      {...props}
    >
      <Link href="/signup" className="text-center no-underline">
        <Value name="apps.app.app.(public).layout.get_started_free_trial" version="21">
          Try for free
        </Value>
      </Link>
    </Button>
  )
})
StartButton.displayName = "StartButton"

export default StartButton
